import React from "react";
import PropTypes from "prop-types";

import { Message } from "semantic-ui-react";

import { useIntegrationAction } from "../../hooks";
import { RedtailForm } from "./components";

export function RedtailSection({ onDone, disabled, children }) {
  const { connect, connecting, error } = useIntegrationAction(onDone);

  return (
    <React.Fragment>
      <Message data-test="error-container" negative hidden={!error}>
        <Message.Header>Error</Message.Header>
        <p>{error}</p>
      </Message>
      <RedtailForm
        onSubmit={({ username, password }) => {
          return connect("REDTAIL", `${username}:${password}`);
        }}
        loading={connecting}
        disabled={disabled}
      />
      {children}
    </React.Fragment>
  );
}

RedtailSection.propTypes = {
  onDone: PropTypes.func,
  disabled: PropTypes.bool,
  children: PropTypes.node,
};

RedtailSection.defaultProps = {
  onDone: () => {},
  disabled: false,
  children: undefined,
};

export default RedtailSection;
